import { Region } from '@/api/apis/resources/schedule';
import { CSTimeGroupOnCallFormSection } from '../sections';

type CSSchedulerSettingsTimeGroupInputsFormProps = {
  isReadOnly: boolean;
  regions: Region[];
};

/**
 * The period counterpart of CSSchedulerSettingsInputsForm.
 * It carries neither the Clinical Leads section nor the At Hub table:
 * `exactlyDailyPhoneSupport` is obsolete on the period contract, and At Hub Weekly has its own tab.
 */
export const CSSchedulerSettingsTimeGroupInputsForm = ({
  regions,
  isReadOnly,
}: CSSchedulerSettingsTimeGroupInputsFormProps) => {
  return (
    <div className="flex flex-col">
      <div className="flex mb-5">
        <CSTimeGroupOnCallFormSection isReadOnly={isReadOnly} regions={regions} />
      </div>
    </div>
  );
};
